define('constants/billingPackageTypeConstants',[], function() {
    return {
        unknown: {
            id: 0,
            key: "unknown",
            name: "Unknown"
        },
        telephony: {
            id: 1,
            key: "telephony",
            name: "PATLive Flex"
        },
        liveReceptionist: {
            id: 2,
            key: "liveReceptionist",
            name: "Live Receptionist"
        },
        webChat: {
            id: 3,
            key: "webChat",
            name: "Web Chat"
        },
        outboundCalling: {
            id: 4,
            key: "outboundCalling",
            name: "Outbound Calling"
        }
    };
});
